module.exports = __webpack_public_path__ + "static/media/loading.ed16f917.gif";